export const GET_BOOKINGS = 'GET_BOOKINGS';